import { Directive, HostListener, HostBinding  } from '@angular/core';

@Directive({
    selector: '[appDropdown]'
})

export class DropdownDirective {
    @HostBinding('class.show') isOpen = false;
    @HostListener('click') toggleOpen() {
        this.isOpen = !this.isOpen;
    }
}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/shared/dropdown.directive.ts